@if (state(); as state) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <div class="flex flex-col gap-2.5">
        <app-page-title>
          {{ 'cockpit.settings.page.title' | transloco }}
        </app-page-title>
        @if (state.isLoading) {
          <app-breadcrumb-nav-skeleton />
        } @else if (state.data) {
          <app-settings-breadcrumb-nav [organization]="state.data" />
        }
      </div>
    </app-page-header>
    @if (!state.error) {
      <div class="flex flex-col gap-5">
        @if (state.isLoading) {
          <app-nav-skeleton />
        } @else if (state.data) {
          <app-settings-nav />
        }

        <div>
          <router-outlet />
        </div>
      </div>
    } @else {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId()])"
        class="block"
        style="height: calc(100vh - 20rem)"
      />
    }
  </app-organization-sidebar-layout>
}
